import { createBrowserHistory } from 'history'
import { take } from 'lodash'

function getBasename() {
  if (window.location.origin.match(/pr.howie.vericred.com/)) {
    const pathname = window.location.pathname
    return take(pathname.split('/'), 2).join('/')
  }

  return ''
}

export const basename = getBasename()

export default createBrowserHistory({
  basename
})
